module.exports = __webpack_public_path__ + "static/media/view3.b0c214c1.jpg";